import { useEffect, useState } from 'react';
import { Eye } from 'lucide-react';
import axios from 'axios';

const API = `${window.location.origin}/api`;

/**
 * #21 — Live activity feed (subtle).
 * Shows "X people viewing this scent right now" — driven by /api/products/{id}/live-views,
 * which counts heartbeats on this product page in the last 5 min.
 * Falls back gracefully (renders nothing) if endpoint missing or count is 0.
 */
export default function LiveProductViewers({ productId }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!productId) return;
    let cancelled = false;
    const tick = async () => {
      try {
        const r = await axios.get(`${API}/products/${productId}/live-views`);
        if (!cancelled) setCount(r.data?.viewing || 0);
      } catch { /* silent */ }
    };
    tick();
    const id = setInterval(tick, 25 * 1000);
    return () => { cancelled = true; clearInterval(id); };
  }, [productId]);

  if (count <= 1) return null; // Don't show "1 person" — feels lonely

  return (
    <div
      className="inline-flex items-center gap-2 px-2.5 py-1 bg-[#1C7D3F]/10 border border-[#1C7D3F]/25 text-[#1C7D3F] text-[11px] font-sans"
      data-testid="live-product-viewers"
      title="Active viewers in the last 5 minutes"
    >
      <span className="live-pulse" />
      <span className="font-medium">{count} people</span>
      <span className="text-[#1C7D3F]/70">viewing now</span>
    </div>
  );
}
